<template>
  <div v-if="setted" style="height: 100%;">
    <div class="top-str">{{id ? '記事修正': '記事作成'}}</div>
    <div class="a-top">
      <input type="text" class="a-title input" placeholder="タイトル" v-model="title">
      <button class="button" @click="back()">キャンセル</button>
      <button class="button is-primary" @click="submit()">送信</button>
    </div>
    <quill-editor class="a-body" :options="QUILL_OPTION" v-model="body"></quill-editor>
  </div>
</template>

<script>
export default {
  name: 'ArticleWrite',
  data () {
    return {
      QUILL_OPTION: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          // toolbar: [[{ size: [ 'small', false, 'large', 'huge' ]}], ['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
          toolbar: [['bold', 'italic', 'underline', 'strike'],        // toggled buttons

                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],

                    ['clean']]  
        }
      },
      setted: false,
      title: '',
      body: '',
      id: null
    }
  },
  methods: {
    set (article) {
      this.setted = true
      if (!article) return
      this.title = article.title
      this.body = article.body
      this.id = article.id
    },
    back () {
      this.$emit('back', this.id)
    },
    submit () {
      if (this.title.replace(' ', '').replace('　', '') == '') this.title = '(無題)'
      if (this.id) this.$emit('submit', {id: this.id, title: this.title, body: this.body})
      else this.$emit('submit', {title: this.title, body: this.body})
    },
  }
}
</script>

<style scoped lang="scss">
.top-str {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}
.a-top {
  display: flex;
  margin-bottom: 8px;

  button {
    margin-left: 8px;
  }
}
.a-title{
  width: 100%;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
}
.a-body {
  width: 100%;
  height: calc(100% - 75px);

  .ql-toolbar {
    height: 44px;
    white-space: nowrap;
    overflow-x: scroll;
  }

  .ql-container {
    height: calc(100% - 44px);
  }
}

.a-body /deep/ .ql-toolbar {
  height: 44px;
  white-space: nowrap;
  overflow-x: scroll;
}

.a-body /deep/ .ql-container {
  height: calc(100% - 44px);
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Forum/ArticleWrite.vue